export class Parametro {
  public id: number;
  public codigo: string;
  public descripcion: string;
  public nombre: string;
}
